// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file tracker/v1/data_health.proto (package tracker.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";

/**
 * @generated from message tracker.v1.GetDataHealthRequest
 */
export class GetDataHealthRequest extends Message<GetDataHealthRequest> {
  constructor(data?: PartialMessage<GetDataHealthRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetDataHealthRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetDataHealthRequest {
    return new GetDataHealthRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetDataHealthRequest {
    return new GetDataHealthRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetDataHealthRequest {
    return new GetDataHealthRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetDataHealthRequest | PlainMessage<GetDataHealthRequest> | undefined, b: GetDataHealthRequest | PlainMessage<GetDataHealthRequest> | undefined): boolean {
    return proto3.util.equals(GetDataHealthRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetDataHealthResponse
 */
export class GetDataHealthResponse extends Message<GetDataHealthResponse> {
  /**
   * @generated from field: tracker.v1.DataHealth health = 1;
   */
  health?: DataHealth;

  constructor(data?: PartialMessage<GetDataHealthResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetDataHealthResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "health", kind: "message", T: DataHealth },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetDataHealthResponse {
    return new GetDataHealthResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetDataHealthResponse {
    return new GetDataHealthResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetDataHealthResponse {
    return new GetDataHealthResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetDataHealthResponse | PlainMessage<GetDataHealthResponse> | undefined, b: GetDataHealthResponse | PlainMessage<GetDataHealthResponse> | undefined): boolean {
    return proto3.util.equals(GetDataHealthResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.DataHealth
 */
export class DataHealth extends Message<DataHealth> {
  /**
   * RFC3339
   *
   * @generated from field: string generated_at = 1;
   */
  generatedAt = "";

  /**
   * @generated from field: tracker.v1.TrafficHealth traffic = 2;
   */
  traffic?: TrafficHealth;

  /**
   * @generated from field: tracker.v1.JournalHealth journal = 3;
   */
  journal?: JournalHealth;

  /**
   * @generated from field: tracker.v1.ReportsHealth reports = 4;
   */
  reports?: ReportsHealth;

  /**
   * @generated from field: tracker.v1.LeadDeliveryHealth leads = 5;
   */
  leads?: LeadDeliveryHealth;

  /**
   * @generated from field: repeated tracker.v1.MissingFxCurrency missing_fx = 6;
   */
  missingFx: MissingFxCurrency[] = [];

  /**
   * Filled once the postback journal reports outcomes; absent means "not
   * measured", which the screen must not show as zero.
   *
   * @generated from field: repeated tracker.v1.UnmappedPostbackStatus unmapped_statuses = 7;
   */
  unmappedStatuses: UnmappedPostbackStatus[] = [];

  /**
   * @generated from field: repeated tracker.v1.PostbacksWithoutClick postbacks_without_click = 8;
   */
  postbacksWithoutClick: PostbacksWithoutClick[] = [];

  /**
   * @generated from field: tracker.v1.DataCoverage coverage = 9;
   */
  coverage?: DataCoverage;

  /**
   * @generated from field: tracker.v1.CurrencyRatesHealth rates = 10;
   */
  rates?: CurrencyRatesHealth;

  /**
   * Issues ordered most-expensive first; the screen renders one row each.
   *
   * @generated from field: repeated tracker.v1.DataHealthIssue issues = 11;
   */
  issues: DataHealthIssue[] = [];

  /**
   * When vibe-fb last pushed ad spend (the status line's «Расход Facebook N
   * мин назад»).
   *
   * @generated from field: tracker.v1.SpendSyncHealth spend_sync = 12;
   */
  spendSync?: SpendSyncHealth;

  constructor(data?: PartialMessage<DataHealth>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.DataHealth";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "generated_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "traffic", kind: "message", T: TrafficHealth },
    { no: 3, name: "journal", kind: "message", T: JournalHealth },
    { no: 4, name: "reports", kind: "message", T: ReportsHealth },
    { no: 5, name: "leads", kind: "message", T: LeadDeliveryHealth },
    { no: 6, name: "missing_fx", kind: "message", T: MissingFxCurrency, repeated: true },
    { no: 7, name: "unmapped_statuses", kind: "message", T: UnmappedPostbackStatus, repeated: true },
    { no: 8, name: "postbacks_without_click", kind: "message", T: PostbacksWithoutClick, repeated: true },
    { no: 9, name: "coverage", kind: "message", T: DataCoverage },
    { no: 10, name: "rates", kind: "message", T: CurrencyRatesHealth },
    { no: 11, name: "issues", kind: "message", T: DataHealthIssue, repeated: true },
    { no: 12, name: "spend_sync", kind: "message", T: SpendSyncHealth },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DataHealth {
    return new DataHealth().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DataHealth {
    return new DataHealth().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DataHealth {
    return new DataHealth().fromJsonString(jsonString, options);
  }

  static equals(a: DataHealth | PlainMessage<DataHealth> | undefined, b: DataHealth | PlainMessage<DataHealth> | undefined): boolean {
    return proto3.util.equals(DataHealth, a, b);
  }
}

/**
 * Traffic as ClickHouse sees it, after the traffic class (decision 01:
 * «Клики» = people; visits = people + bots).
 *
 * @generated from message tracker.v1.TrafficHealth
 */
export class TrafficHealth extends Message<TrafficHealth> {
  /**
   * @generated from field: int64 visits_last_hour = 1;
   */
  visitsLastHour = protoInt64.zero;

  /**
   * @generated from field: int64 people_last_hour = 2;
   */
  peopleLastHour = protoInt64.zero;

  /**
   * @generated from field: int64 bots_last_hour = 3;
   */
  botsLastHour = protoInt64.zero;

  /**
   * RFC3339, empty when none in the last day
   *
   * @generated from field: string last_visit_at = 4;
   */
  lastVisitAt = "";

  /**
   * @generated from field: repeated tracker.v1.TrafficClassCount classes_last_day = 5;
   */
  classesLastDay: TrafficClassCount[] = [];

  constructor(data?: PartialMessage<TrafficHealth>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.TrafficHealth";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "visits_last_hour", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "people_last_hour", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "bots_last_hour", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "last_visit_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "classes_last_day", kind: "message", T: TrafficClassCount, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TrafficHealth {
    return new TrafficHealth().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TrafficHealth {
    return new TrafficHealth().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TrafficHealth {
    return new TrafficHealth().fromJsonString(jsonString, options);
  }

  static equals(a: TrafficHealth | PlainMessage<TrafficHealth> | undefined, b: TrafficHealth | PlainMessage<TrafficHealth> | undefined): boolean {
    return proto3.util.equals(TrafficHealth, a, b);
  }
}

/**
 * @generated from message tracker.v1.TrafficClassCount
 */
export class TrafficClassCount extends Message<TrafficClassCount> {
  /**
   * human | verified_bot | meta_crawler | listed_ip | crawler | no_ua | datacenter | bot_score | bot (recorded before classes)
   *
   * @generated from field: string traffic_class = 1;
   */
  trafficClass = "";

  /**
   * @generated from field: int64 visits = 2;
   */
  visits = protoInt64.zero;

  constructor(data?: PartialMessage<TrafficClassCount>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.TrafficClassCount";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "traffic_class", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "visits", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TrafficClassCount {
    return new TrafficClassCount().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TrafficClassCount {
    return new TrafficClassCount().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TrafficClassCount {
    return new TrafficClassCount().fromJsonString(jsonString, options);
  }

  static equals(a: TrafficClassCount | PlainMessage<TrafficClassCount> | undefined, b: TrafficClassCount | PlainMessage<TrafficClassCount> | undefined): boolean {
    return proto3.util.equals(TrafficClassCount, a, b);
  }
}

/**
 * The PostgreSQL journal every event passes through.
 *
 * @generated from message tracker.v1.JournalHealth
 */
export class JournalHealth extends Message<JournalHealth> {
  /**
   * @generated from field: int64 pending = 1;
   */
  pending = protoInt64.zero;

  /**
   * Pending longer than 5 minutes and not waiting for a click.
   *
   * @generated from field: int64 stuck = 2;
   */
  stuck = protoInt64.zero;

  /**
   * RFC3339
   *
   * @generated from field: string oldest_stuck_at = 3;
   */
  oldestStuckAt = "";

  /**
   * Parked after exhausting retries (the tracker's DLQ).
   *
   * @generated from field: int64 dead = 4;
   */
  dead = protoInt64.zero;

  /**
   * Retrying because the click/step has not arrived yet.
   *
   * @generated from field: int64 awaiting_click = 5;
   */
  awaitingClick = protoInt64.zero;

  constructor(data?: PartialMessage<JournalHealth>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.JournalHealth";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pending", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "stuck", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "oldest_stuck_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "dead", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "awaiting_click", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): JournalHealth {
    return new JournalHealth().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): JournalHealth {
    return new JournalHealth().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): JournalHealth {
    return new JournalHealth().fromJsonString(jsonString, options);
  }

  static equals(a: JournalHealth | PlainMessage<JournalHealth> | undefined, b: JournalHealth | PlainMessage<JournalHealth> | undefined): boolean {
    return proto3.util.equals(JournalHealth, a, b);
  }
}

/**
 * Delivery of journal events into ClickHouse reports.
 *
 * @generated from message tracker.v1.ReportsHealth
 */
export class ReportsHealth extends Message<ReportsHealth> {
  /**
   * @generated from field: int64 pending = 1;
   */
  pending = protoInt64.zero;

  /**
   * age of the oldest undelivered projection
   *
   * @generated from field: double lag_seconds = 2;
   */
  lagSeconds = 0;

  constructor(data?: PartialMessage<ReportsHealth>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ReportsHealth";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pending", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "lag_seconds", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReportsHealth {
    return new ReportsHealth().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReportsHealth {
    return new ReportsHealth().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReportsHealth {
    return new ReportsHealth().fromJsonString(jsonString, options);
  }

  static equals(a: ReportsHealth | PlainMessage<ReportsHealth> | undefined, b: ReportsHealth | PlainMessage<ReportsHealth> | undefined): boolean {
    return proto3.util.equals(ReportsHealth, a, b);
  }
}

/**
 * @generated from message tracker.v1.LeadDeliveryHealth
 */
export class LeadDeliveryHealth extends Message<LeadDeliveryHealth> {
  /**
   * @generated from field: int64 pending = 1;
   */
  pending = protoInt64.zero;

  /**
   * @generated from field: int64 failing = 2;
   */
  failing = protoInt64.zero;

  /**
   * @generated from field: int64 dead = 3;
   */
  dead = protoInt64.zero;

  /**
   * @generated from field: int64 delivered_last_hour = 4;
   */
  deliveredLastHour = protoInt64.zero;

  /**
   * @generated from field: double oldest_pending_seconds = 5;
   */
  oldestPendingSeconds = 0;

  constructor(data?: PartialMessage<LeadDeliveryHealth>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.LeadDeliveryHealth";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pending", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "failing", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "dead", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "delivered_last_hour", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "oldest_pending_seconds", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LeadDeliveryHealth {
    return new LeadDeliveryHealth().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LeadDeliveryHealth {
    return new LeadDeliveryHealth().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LeadDeliveryHealth {
    return new LeadDeliveryHealth().fromJsonString(jsonString, options);
  }

  static equals(a: LeadDeliveryHealth | PlainMessage<LeadDeliveryHealth> | undefined, b: LeadDeliveryHealth | PlainMessage<LeadDeliveryHealth> | undefined): boolean {
    return proto3.util.equals(LeadDeliveryHealth, a, b);
  }
}

/**
 * @generated from message tracker.v1.MissingFxCurrency
 */
export class MissingFxCurrency extends Message<MissingFxCurrency> {
  /**
   * @generated from field: string currency = 1;
   */
  currency = "";

  /**
   * @generated from field: int64 conversions = 2;
   */
  conversions = protoInt64.zero;

  /**
   * decimal string in `currency`
   *
   * @generated from field: string amount = 3;
   */
  amount = "";

  constructor(data?: PartialMessage<MissingFxCurrency>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.MissingFxCurrency";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "conversions", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "amount", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MissingFxCurrency {
    return new MissingFxCurrency().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MissingFxCurrency {
    return new MissingFxCurrency().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MissingFxCurrency {
    return new MissingFxCurrency().fromJsonString(jsonString, options);
  }

  static equals(a: MissingFxCurrency | PlainMessage<MissingFxCurrency> | undefined, b: MissingFxCurrency | PlainMessage<MissingFxCurrency> | undefined): boolean {
    return proto3.util.equals(MissingFxCurrency, a, b);
  }
}

/**
 * @generated from message tracker.v1.UnmappedPostbackStatus
 */
export class UnmappedPostbackStatus extends Message<UnmappedPostbackStatus> {
  /**
   * @generated from field: string network_id = 1;
   */
  networkId = "";

  /**
   * @generated from field: string raw_status = 2;
   */
  rawStatus = "";

  /**
   * @generated from field: int64 conversions = 3;
   */
  conversions = protoInt64.zero;

  /**
   * decimal string
   *
   * @generated from field: string payout = 4;
   */
  payout = "";

  /**
   * @generated from field: string currency = 5;
   */
  currency = "";

  constructor(data?: PartialMessage<UnmappedPostbackStatus>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.UnmappedPostbackStatus";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "network_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "raw_status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "conversions", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "payout", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UnmappedPostbackStatus {
    return new UnmappedPostbackStatus().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UnmappedPostbackStatus {
    return new UnmappedPostbackStatus().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UnmappedPostbackStatus {
    return new UnmappedPostbackStatus().fromJsonString(jsonString, options);
  }

  static equals(a: UnmappedPostbackStatus | PlainMessage<UnmappedPostbackStatus> | undefined, b: UnmappedPostbackStatus | PlainMessage<UnmappedPostbackStatus> | undefined): boolean {
    return proto3.util.equals(UnmappedPostbackStatus, a, b);
  }
}

/**
 * @generated from message tracker.v1.PostbacksWithoutClick
 */
export class PostbacksWithoutClick extends Message<PostbacksWithoutClick> {
  /**
   * @generated from field: string network_id = 1;
   */
  networkId = "";

  /**
   * @generated from field: int64 count = 2;
   */
  count = protoInt64.zero;

  /**
   * RFC3339
   *
   * @generated from field: string oldest_at = 3;
   */
  oldestAt = "";

  constructor(data?: PartialMessage<PostbacksWithoutClick>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.PostbacksWithoutClick";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "network_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "oldest_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PostbacksWithoutClick {
    return new PostbacksWithoutClick().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PostbacksWithoutClick {
    return new PostbacksWithoutClick().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PostbacksWithoutClick {
    return new PostbacksWithoutClick().fromJsonString(jsonString, options);
  }

  static equals(a: PostbacksWithoutClick | PlainMessage<PostbacksWithoutClick> | undefined, b: PostbacksWithoutClick | PlainMessage<PostbacksWithoutClick> | undefined): boolean {
    return proto3.util.equals(PostbacksWithoutClick, a, b);
  }
}

/**
 * Shares of the last day/week that are trustworthy, as numerator/denominator
 * so the screen formats the percentage once.
 *
 * @generated from message tracker.v1.DataCoverage
 */
export class DataCoverage extends Message<DataCoverage> {
  /**
   * @generated from field: int64 revenue_conversions = 1;
   */
  revenueConversions = protoInt64.zero;

  /**
   * @generated from field: int64 revenue_conversions_in_reporting_currency = 2;
   */
  revenueConversionsInReportingCurrency = protoInt64.zero;

  /**
   * Zero denominators mean "not measured yet" (no postback journal).
   *
   * @generated from field: int64 postbacks_last_day = 3;
   */
  postbacksLastDay = protoInt64.zero;

  /**
   * @generated from field: int64 postbacks_matched_last_day = 4;
   */
  postbacksMatchedLastDay = protoInt64.zero;

  /**
   * Spend of the last 7 workspace days, USD decimal strings, counted by the
   * report engine: all of it, and the part no visit carries — an ad whose
   * link brings no ad id, so the spend belongs to no campaign («расход без
   * кликов», the report's ∅ row). Empty = not measured.
   *
   * @generated from field: string spend_last_week_usd = 5;
   */
  spendLastWeekUsd = "";

  /**
   * @generated from field: string spend_without_clicks_last_week_usd = 6;
   */
  spendWithoutClicksLastWeekUsd = "";

  constructor(data?: PartialMessage<DataCoverage>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.DataCoverage";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "revenue_conversions", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "revenue_conversions_in_reporting_currency", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "postbacks_last_day", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "postbacks_matched_last_day", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "spend_last_week_usd", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "spend_without_clicks_last_week_usd", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DataCoverage {
    return new DataCoverage().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DataCoverage {
    return new DataCoverage().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DataCoverage {
    return new DataCoverage().fromJsonString(jsonString, options);
  }

  static equals(a: DataCoverage | PlainMessage<DataCoverage> | undefined, b: DataCoverage | PlainMessage<DataCoverage> | undefined): boolean {
    return proto3.util.equals(DataCoverage, a, b);
  }
}

/**
 * Currency rates (fx_rates), refreshed hourly by the worker's fx-rates
 * schedule from the ECB and currency-api; a payout is valued at its day's rate.
 *
 * @generated from message tracker.v1.CurrencyRatesHealth
 */
export class CurrencyRatesHealth extends Message<CurrencyRatesHealth> {
  /**
   * Last complete refresh, RFC3339; empty = never refreshed yet.
   *
   * @generated from field: string updated_at = 1;
   */
  updatedAt = "";

  /**
   * Currencies with a rate fixed in the last week.
   *
   * @generated from field: repeated string codes = 2;
   */
  codes: string[] = [];

  /**
   * Currencies of conversions waiting for a rate.
   *
   * @generated from field: repeated string missing_codes = 3;
   */
  missingCodes: string[] = [];

  /**
   * No complete refresh for 48 h (or since rates are kept): a problem, never
   * shown green. Mirrors the TrackerFXRatesStale alert.
   *
   * @generated from field: bool stale = 4;
   */
  stale = false;

  /**
   * Why the last refresh failed, when it did after the last success.
   *
   * @generated from field: string last_error = 5;
   */
  lastError = "";

  constructor(data?: PartialMessage<CurrencyRatesHealth>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CurrencyRatesHealth";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "updated_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "codes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "missing_codes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "stale", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "last_error", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CurrencyRatesHealth {
    return new CurrencyRatesHealth().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CurrencyRatesHealth {
    return new CurrencyRatesHealth().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CurrencyRatesHealth {
    return new CurrencyRatesHealth().fromJsonString(jsonString, options);
  }

  static equals(a: CurrencyRatesHealth | PlainMessage<CurrencyRatesHealth> | undefined, b: CurrencyRatesHealth | PlainMessage<CurrencyRatesHealth> | undefined): boolean {
    return proto3.util.equals(CurrencyRatesHealth, a, b);
  }
}

/**
 * Pushed ad spend (POST /api/v1/cost/ads, tracker.ad_cost_daily): vibe-fb
 * re-sends each ad's day every sync, so the newest write is the last sync.
 *
 * @generated from message tracker.v1.SpendSyncHealth
 */
export class SpendSyncHealth extends Message<SpendSyncHealth> {
  /**
   * RFC3339; empty = no spend pushed in the last three days.
   *
   * @generated from field: string last_pushed_at = 1;
   */
  lastPushedAt = "";

  /**
   * Distinct ads whose spend was pushed in the last 24 hours.
   *
   * @generated from field: int64 ads_last_day = 2;
   */
  adsLastDay = protoInt64.zero;

  constructor(data?: PartialMessage<SpendSyncHealth>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.SpendSyncHealth";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "last_pushed_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ads_last_day", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SpendSyncHealth {
    return new SpendSyncHealth().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SpendSyncHealth {
    return new SpendSyncHealth().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SpendSyncHealth {
    return new SpendSyncHealth().fromJsonString(jsonString, options);
  }

  static equals(a: SpendSyncHealth | PlainMessage<SpendSyncHealth> | undefined, b: SpendSyncHealth | PlainMessage<SpendSyncHealth> | undefined): boolean {
    return proto3.util.equals(SpendSyncHealth, a, b);
  }
}

/**
 * @generated from message tracker.v1.DataHealthIssue
 */
export class DataHealthIssue extends Message<DataHealthIssue> {
  /**
   * unmapped_status | missing_fx | rates_stale | spend_without_clicks | leads_failing | events_dead | events_stuck | postbacks_without_click | reports_lagging | postbacks_silent
   * spend_without_clicks counts whole USD of the last 7 days (DataCoverage);
   * postbacks_silent counts partners silent past their own alert
   * (AffiliateNetwork.silence_alert_seconds, ListNetworkNumbers.silent).
   *
   * @generated from field: string kind = 1;
   */
  kind = "";

  /**
   * money: revenue or a lead is wrong until fixed; warn: numbers late; info.
   *
   * @generated from field: string severity = 2;
   */
  severity = "";

  /**
   * @generated from field: int64 count = 3;
   */
  count = protoInt64.zero;

  constructor(data?: PartialMessage<DataHealthIssue>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.DataHealthIssue";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "kind", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "severity", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DataHealthIssue {
    return new DataHealthIssue().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DataHealthIssue {
    return new DataHealthIssue().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DataHealthIssue {
    return new DataHealthIssue().fromJsonString(jsonString, options);
  }

  static equals(a: DataHealthIssue | PlainMessage<DataHealthIssue> | undefined, b: DataHealthIssue | PlainMessage<DataHealthIssue> | undefined): boolean {
    return proto3.util.equals(DataHealthIssue, a, b);
  }
}

